import { render } from "./GroupRadio.vue?vue&type=template&id=3c57c264"
import script from "./GroupRadio.vue?vue&type=script&lang=js"
export * from "./GroupRadio.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__